import * as types from '../../constants/types/subscribe/SubscribeTypes';

// eslint-disable-next-line import/prefer-default-export
export const subscribeReducer = (state, action) => {
  const { type } = action;
  switch (type) {
    case types.START_PAYMENT_WITH_SLYDE:
      return {
        ...state,
        loadingSlyde: true,
      };

    case types.PAYMENT_WITH_SLYDE_SUCCESS:
      return {
        ...state,
        loadingSlyde: false,
      };

    case types.PAYMENT_WITH_SLYDE_FAILED:
      return {
        ...state,
        loadingSlyde: false,
      };

    case types.START_PAYMENT_WITH_THE_TELLER:
      return {
        ...state,
        loadingTeller: true,
      };

    case types.PAYMENT_WITH_THE_TELLER_SUCCESS:
      return {
        ...state,
        loadingTeller: false,
      };

    case types.PAYMENT_WITH_THE_TELLER_FAILED:
      return {
        ...state,
        loadingTeller: false,
      };

    default:
      throw new Error();
  }
};
